module.exports = __webpack_public_path__ + "static/social-29efd56293fcf24e262161f00c5e0fe2.png";